import * as angular from 'angular';
import {RootScope} from '../types/angular-types';
import AppConstants from '../gorillaboy/AppConstants';
import "./createFolderModal.html";
import './createFolderController';

angular.module('GorillaBoy.directives')
.directive('createFolderMenuOption',
    ['$rootScope',
    '$uibModal',
    'authenticatedUser',
    'FileService',
    'MessageProvider',
    'SignalProvider',
    function ($rootScope: RootScope, $uibModal, authenticatedUser, FileService, MessageProvider, SignalProvider) {
        return {
            template: '<span ng-click="showCreateFolderModal()" style="display: inline-block;height: 100%;width: 100%;outline: none" translate>FILE_TYPES.FOLDER</span>',
            scope : true,
            link: function($scope, $element, attrs) {
                $scope.showCreateFolderModal = function() {
                    //Hide advance search if Visible
                    $rootScope.$broadcast(SignalProvider.Search.HideSearchMenu);

                    $scope.createFolderModal = $uibModal.open({
                        templateUrl: './share-modal/createFolderModal.html',
                        controller: 'createFolderCtrl',
                        resolve: {
                            fileManagerInstance: function() {
                                return $scope.fileManagerInstance;
                            },
                            ParentFolderId : function() {
                                if ($scope.layout.view === AppConstants.ViewTypes.FOLDER_TYPE || $scope.layout.view === AppConstants.ViewTypes.OWN_TYPE) {
                                    return $scope.fileManagerInstance.getCurrentFolder();
                                } else {
                                    return authenticatedUser.getUserInfo().RootFolderId;
                                }
                            }
                        }
                    });

                    $scope.createFolderModal.result.finally(function() {
                        $scope.createFolderModal = null;
                    });
                };

                $scope.$on("$destroy", function() {
                    if ($scope.createFolderModal) {
                        $scope.createFolderModal.close();
                    }
                    $scope.createFolderModal = null;
                });
            }
        };
    }]);
